import React from 'react';
import I18n from 'i18n-js';
import { ISuggestionGroup } from './suggestion_collection';
import Suggestion from './suggestion';

import { IUserContext, withUserContext } from '@reverbdotcom/commons/src/components/user_context_provider';
import RecentlyViewedListingPhotosRow from '../../recently_viewed_listing_photos_row';
import SearchFormTrendingSearches from '../../search_form_trending_searches';
import { reverb_personalization_TrendingSearch } from '../../../schemas/rql';

interface IProps extends IUserContext {
  suggestions: ISuggestionGroup[];
  lastTypedValue: string;
  selectSuggestion: Function;
  selectedSuggestion: Suggestion;
  renderRecentlyViewed?: boolean;
  handleInputChange: Function;
  renderTrendingSearches?: boolean;
  trendingSearchesOnClick?:Function;
  trendingSearches?: reverb_personalization_TrendingSearch[];
}

export class Dropdown extends React.Component<IProps, null> {
  renderSection(section, sectionIdx) {
    return (
      <div
        key={sectionIdx}
        className="site-search__dropdown__section"
      >
        {this.renderSectionHeading(section)}
        <div className="recent-searches__container">
          {section.results.map((r, idx) => this.renderSectionItem(r, idx))}
        </div>
      </div>
    );
  }

  renderSectionHeading(section) {
    if (!section.heading) { return false; }
    if (!section.results.length) { return false; }

    return (
      <div className="site-search__dropdown__section__heading">
        {section.heading}
      </div>
    );
  }

  renderSectionItem(suggestion, idx) {
    const isActive = suggestion.positionEqual(this.props.selectedSuggestion);

    return (
      <suggestion.component
        key={idx}
        suggestion={suggestion}
        active={isActive}
        lastTypedValue={this.props.lastTypedValue}
        selectSuggestion={this.props.selectSuggestion}
        handleInputChange={this.props.handleInputChange}
      />
    );
  }

  renderRecentlyViewed() {
    if (!this.props.renderRecentlyViewed) { return false; }

    return (
      <div className="site-search__dropdown__section">
        <RecentlyViewedListingPhotosRow
          title={
            <div className="site-search__dropdown__section__heading">
              {I18n.t('discovery.recentlyViewed.title')}
            </div>
          }
        />
      </div>
    );
  }

  render() {
    const { suggestions, renderTrendingSearches, trendingSearches, trendingSearchesOnClick } = this.props;

    return (
      <div className="site-search__dropdown">
        {suggestions.map((s, idx) => this.renderSection(s, idx))}
        {renderTrendingSearches &&
          <SearchFormTrendingSearches
            trendingSearches={trendingSearches}
            onClick={trendingSearchesOnClick}
          />
        }
        {this.renderRecentlyViewed()}
      </div>
    );
  }
}

export default withUserContext(Dropdown);
